<template>
  <v-layout>
    <div
      v-if="model"
      class="container pt-5 px-3"
    >
      <public-show-header
        :model="model"
      />

      <!-- Reading order requested by Devloc: photos (2×2), promotion,
           inclusions, details, then the rent agents -->
      <public-show-slider
        :media="detailMedia"
        class="mb-5"
      />

      <public-show-promotion
        v-if="model.promotion_details"
        :promotion="model.promotion_details"
      />

      <public-show-inclusions
        :inclusions="model.active_inclusions ?? []"
      />

      <div class="mb-5">
        <public-show-card-left
          :model="model"
        />
      </div>

      <public-show-agent
        v-if="model.latest_status && model.latest_status.rent_agents"
        :rent-agents="model.latest_status.rent_agents"
        :property-id="model.id"
      />
    </div>
  </v-layout>
</template>

<script>
import Header from "./sections/Header";
import Slider from "./sections/Slider";
import Agent from "./sections/Agent";
import inclusions from "./sections/Inclusions";
import Promotion from "./sections/Promotion";

import CardLeft from "./sections/CardLeft";

export default {
  components: {
    "public-show-header": Header,
    "public-show-slider": Slider,
    "public-show-agent": Agent,
    "public-show-inclusions": inclusions,
    "public-show-promotion": Promotion,
    "public-show-card-left": CardLeft
  },
  metaInfo() {
    return {
      title: this.title,
      __property: this.title // for breadcrumb
    };
  },
  data() {
    return {
      model: null,
      billing_address: {},
      loading: true,
    };
  },
  computed: {
    title() {
      if (this.model && this.model.full_address_with_unity) {
        return this.model.full_address_with_unity;
      }
      return "";
    },
    // Detail page leads with the videos, then the photos
    detailMedia() {
      const media = (this.model && this.model.media) || [];
      const isVideo = (m) => m.mime_type && m.mime_type.startsWith("video/");

      return [...media.filter(isVideo), ...media.filter((m) => !isVideo(m))];
    }
  },
  watch: {
    $route(to, from) {
      this.query();
    }
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      this.$http
        .get(
          this.$laravel.route("public.property.show", {
            slug: this.$route.params.slug
          })
        )
        .then(response => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch(e => {
          console.error(e);
          this.$router.push("/");
        });
    },
  }
};
</script>
